import { render } from "./GoodItem.vue?vue&type=template&id=2c2eb311&scoped=true"
import script from "./GoodItem.vue?vue&type=script&lang=ts"
export * from "./GoodItem.vue?vue&type=script&lang=ts"

import "./GoodItem.vue?vue&type=style&index=0&id=2c2eb311&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2c2eb311"

export default script